import React from 'react';
import { credibility, event } from '../data/masterclass';
export function Credibility() {
  return <section aria-labelledby="credibility-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-26" data-mp="2kplqz530q7zk">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-27" data-mp="2zei9jw2pb3ef">
        <div className="grid grid-cols-1 items-start gap-10 sm:grid-cols-[minmax(220px,0.75fr)_1.25fr] sm:gap-12" data-id="element-28" data-mp="2umgphnzak8du">
          <img src={event.portraitUrl} alt="Curtis and Spring Eatmon IV" className="w-full max-w-sm object-cover" data-id="element-29" data-mp="38dlqateeb6pr" />

          <div data-id="element-30" data-mp="3ickqrop0bw1o">
            <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-31" data-mp="3id4anay7wuic">
              Curtis &amp; Spring Eatmon IV
            </p>
            <h2 id="credibility-heading" className="mt-4 font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-32" data-mp="3de9i3hag7rl1">
              We didn’t learn this from the sidelines.{' '}
              <span className="text-gold" data-id="element-33" data-mp="31g74g5sd8b8e">We’ve had to live it.</span>
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-white/70" data-id="element-34" data-mp="31e47t2wpjjup">
              {credibility.body}
            </p>
          </div>
        </div>

        <dl className="mt-12 grid gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="3afkd4w8o0vs2">
          {credibility.proof.map(block => <div key={block.label} className="bg-ink p-7" data-id="element-36" data-mp="3k77zwjua1on7">
              <dt className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-37" data-mp="3k8rgkbjui1pi">
                {block.label}
              </dt>
              <dd className="mt-3 leading-relaxed text-white/70" data-id="element-38" data-mp="3t6v57gq4nelj">{block.body}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}